import './EditCms.scss'

import React from 'react'
import {style} from '../../util/style'
import {useLanguage} from '../../util/i18n'

const styles = style('editcms')

export const EditCms: React.FC<{
	is_admin: boolean
	project: string
	id: number
}> = ({is_admin, project, id}) => {
	const language = useLanguage()
	if (!is_admin || window.innerWidth < 1200) return null
	const href = `/admin/project/${project}/${language}/entry/${id}`

	return (
		<a href={href} target={'_blank'} className={styles()}>
			{switchLang(language)}
		</a>
	)
}

function switchLang(lang) {
	switch (lang) {
		case 'fr':
			return 'Editer en CMS'
		case 'nl':
			return 'Wijzig in CMS'
		default:
			return 'Edit in CMS'
	}
}
